import { UNAVAILABLE_COPY } from "./workspaceLiveTypes";

export const LIVE_UNAVAILABLE = {
  notInCache: UNAVAILABLE_COPY.notInCache,
  notInOutput: UNAVAILABLE_COPY.notInOutput,
  companyName: UNAVAILABLE_COPY.notInCache,
  industry: UNAVAILABLE_COPY.notInCache,
  emaDaily: UNAVAILABLE_COPY.notYetCached,
  emaWeekly: UNAVAILABLE_COPY.notYetCached,
  atr: UNAVAILABLE_COPY.notYetCached,
  relativeStrength: UNAVAILABLE_COPY.notYetCached,
  smaSeries: UNAVAILABLE_COPY.notInCache,
  rsiSeries: UNAVAILABLE_COPY.notInCache,
  macdSeries: UNAVAILABLE_COPY.notInCache,
  trendTape: UNAVAILABLE_COPY.notInCache,
  regimeAlignment: UNAVAILABLE_COPY.alignment,
  weeklyYield: UNAVAILABLE_COPY.notInOutput,
  perTradeChart: UNAVAILABLE_COPY.notInOutput,
  inventedPremium: UNAVAILABLE_COPY.notInOutput,
  strategyRows: UNAVAILABLE_COPY.notInOutput,
  profile: UNAVAILABLE_COPY.notInCache,
  executives: UNAVAILABLE_COPY.notInCache,
  employees: UNAVAILABLE_COPY.notInCache,
  statements: UNAVAILABLE_COPY.notInCache,
  peers: UNAVAILABLE_COPY.notInCache,
  estimateHistory: UNAVAILABLE_COPY.notInCache,
  surpriseHistory: UNAVAILABLE_COPY.notInCache,
  predictedEarnings: UNAVAILABLE_COPY.notInCache,
  analystDispersion: UNAVAILABLE_COPY.notInCache,
  printMove: UNAVAILABLE_COPY.notInCache,
  familyContext: "Historical strategy-family context",
  sentisense: "Not requested in this preview",
  historicalTitle: "Historical strategy-family context",
  historicalExplainer:
    "Historical strategy-family context. These are historical Backtest Lab results, not current option quotes.",
  currentPricedTitle: "Current priced structures",
  currentPricedUnverified:
    "Current priced structures are unavailable. MarkovLab will not treat this cache as current, delayed, observed, executable, or valid premium pricing because option quote time is not verified.",
  currentPricedNoChain:
    "Current priced structures are unavailable. No option chain is present in the current cached output.",
  currentPricedFreshnessBlocked:
    "Current priced structures are unavailable. Not available under current screen conditions.",
  currentPricedNoStructure:
    "Selected structure is not available under the current screen conditions.",
  currentPricedPremiumUnavailable:
    "Premium is unavailable. No valid current premium can be shown from this cache.",
  currentPricedNoTable:
    "Current priced structures are not shown as a premium table in this view. A verified quote time alone is not a priced trade.",
  pricingMethodUnavailable:
    "Pricing method is unavailable because there is no verified current premium.",
  historicalBadge: "Historical cache",
  currentBadgeUnverified: "Quote time unverified",
  currentBadgeUnavailable: "Current quote unavailable",
  historicalMetricLabels: {
    sample_size: "Current-regime historical sample size",
    win_rate: "Historical win rate",
    avg_return_on_risk: "Historical average return on risk",
    assignment_rate: "Assignment rate",
    max_loss: "Historical maximum loss",
    profit_factor: "Profit factor",
  },
  researchChoose: "Choose a strategy to view historical Backtest context.",
  researchUnavailableTitle: "Historical strategy focus unavailable.",
  researchUnavailableDetail:
    "The requested strategy is not available in the current historical dataset.",
  researchSimulationLabel: "Canonical 30-DTE historical simulation",
  researchMethodology:
    "These are historical Backtest Lab results, not current option quotes. This panel is a canonical 30-DTE historical simulation. It is not based on the current URL expiry or the selected DTE window.",
  researchLimited:
    "Limited historical evidence. Sample size is below the minimum threshold.",
  researchContextUnavailable: "Regime comparison unavailable from current cached output.",
  currentActionTitle: "Current product action",
  currentActionUnavailable: "Current action unavailable",
  currentActionDetail: "Requires valid broker-entitled current quote data",
  railTitle: "Historical Evidence & Conditions",
  railHistoricalKicker: "A · Historical research",
  railQuoteKicker: "B · Current quote",
  railActionKicker: "C · Current product action",
  railHistoricalAvailable: "Historical evidence available",
  railHistoricalLimited: "Limited historical evidence",
  railHistoricalUnavailable: "Historical strategy focus unavailable",
  railHistoricalChoose: "Choose a strategy to view historical Backtest context.",
  railQuoteSummary: "Quote time unverified",
  railActionSummary: "Current action unavailable",
};

export const LIVE_LABEL = {
  cached: "cached data",
  observed: "observed data",
  timestampUnavailable: UNAVAILABLE_COPY.timestamp,
  indicative: UNAVAILABLE_COPY.indicative,
  dataUnavailable: "data unavailable",
  notEvaluated: "not evaluated",
  historicalAvailable: UNAVAILABLE_COPY.historicalAvailable,
  historicalLimited: UNAVAILABLE_COPY.historicalLimited,
  historicalUnavailable: UNAVAILABLE_COPY.historicalUnavailable,
  changeVsPriorSession: "Change vs prior cached session close",
  changeSincePrior: "Change since prior cached close",
  changeQuality: "Derived from cached closing prices",
  earningsPast: "Past date supplied — next event unavailable",
};
